// Port of api/fuel/app/classes/controller/api/monty/games/comments.php
import { buildCommentsResponse } from 'offline/api/games/shared'

export default function(params) {
	return buildCommentsResponse(params)
}
